import React from 'react';

const EmptyState = ({ icon, title, subtitle }) => (
  <div className="empty-state">
    <div className="empty-icon">{icon}</div>
    <div className="empty-text">{title}</div>
    <div className="empty-subtext">{subtitle}</div>
  </div>
);

export default EmptyState;